import React from 'react';

import { useOrientation } from '@/lib/hooks/useOrientation';

import { deleteTodo } from './helpers';
import styles from './index.module.scss';

type DeleteModalProps = {
  todoId: string;
  closeDeleteConfirmModal: () => void;
};

const DeleteModal = ({ todoId, closeDeleteConfirmModal }: DeleteModalProps) => {
  const isLandscape = useOrientation() === 'LANDSCAPE';

  return (
    <div className={styles.mask}>
      <div className={styles.modalContainer}>
        {isLandscape ? (
          <div className={styles['modalHeaderContainer-landscape']}>
            <img src="/icon/ic_exclamationMark.svg" alt="驚嘆號圖片" />
            <div className={styles['titleContainer-landscape']}>
              <h3>確定刪除此排程？</h3>
              <p>刪除後將無法復原!!</p>
            </div>
          </div>
        ) : (
          <>
            <img src="/icon/ic_exclamationMark.svg" alt="驚嘆號圖片" />
            <div className={styles.titleContainer}>
              <h3>確定刪除此排程？</h3>
              <p>刪除後將無法復原!!</p>
            </div>
          </>
        )}
        <div className={styles.buttonsContainer}>
          <button
            className={styles.okBtn}
            onClick={() => deleteTodo(todoId, closeDeleteConfirmModal)}
          >
            確定
          </button>
          <button
            className={styles.cancelBtn}
            onClick={closeDeleteConfirmModal}
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
